import { useMutation } from "@apollo/client";
import { DOCUMENT_ORDER } from "graphql/mutation/document-gql";
import { useTranslation } from "components/use-hooks";

const useMutationDocumentOrder = () => {
  const translations = useTranslation();
  const [mutate, { loading }] = useMutation(DOCUMENT_ORDER);

  const setOrder = async ({ id, row_order }) => {
    const result = await mutate({ variables: { input: { id, row_order } } });
    const savedDocument = result.data?.documentUpdate?.document;
    if (!savedDocument?.id || String(savedDocument.id) !== String(id) || savedDocument.row_order !== row_order) {
      throw new Error(translations["APP_SETTINGS.Error_InvalidResponse"]);
    }
    return savedDocument;
  };

  return { setOrder, loading, loadingMutationDocumentOrder: loading };
};

export default useMutationDocumentOrder;
